// REACT
import { createContext } from 'react'

// LOCAL IMPORTS
import config, { Config } from '@/config'

export default createContext<Config>(config)
